"use client";

import HomePageVariant from "@/components/HomePageVariant";

/**
 * HomePageVariant 路由页面
 * 用于显示 HomePageVariant 组件的独立路由
 */
export default function HomePageVariantRoute() {
  return <HomePageVariant />;
}
